import { useStore } from 'effector-react'
import { useTranslation } from 'react-i18next'
import { viewerModel } from '~/entities/viewer'
import { EditEmployee } from '~/features/Employees/EditEmployee'
import { Container, PageTitle, PageContainer } from '~/shared/ui/Layout'

function UserPersonalData() {
  const { t } = useTranslation()
  const userId = useStore(viewerModel.$currentUserId)

  return (
    <PageContainer title={t('personal data')}>
      <Container isHeader>
        <PageTitle>{t('personal data')}</PageTitle>
      </Container>
      <EditEmployee employeeId={userId as UniqueId} canUpdate={false} />
    </PageContainer>
  )
}

export default UserPersonalData
